import React from 'react';
import {Link} from "react-router-dom";

export default class FileUploadAudit extends React.Component {
	constructor(props) {
		super(props);

		if (typeof window.file_upload_audit_selected === "undefined") {
			window.file_upload_audit_selected = {};
		}

		this.updateButton(Object.keys(window.file_upload_audit_selected).length)

		let _state = {};
		window.Route.on({
			'/v2/file-upload-audit': () => {
				_state = {
					mode: 'list',
					dates: [],
				};
			},
			// '/v2/signature/new': () => {
			//     _state = {
			//         mode: 'create',
			//         signature: [],
			//     };
			// },
			// '/v2/signature/:signature_id': (params) => {
			//     _state = {
			//         mode: 'view',
			//         params: params,
			//         signature: [],
			//     };
			// },
			// '/v2/signature/:signature_id/edit': (params) => {
			//     _state = {
			//         mode: 'edit',
			//         params: params,
			//         signature: [],
			//     };
			// }
		}).match();

		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/file-upload-audit': () => {
					this.setState({
						mode: 'list',
						is_table_loading: true,
					}, () => {
						this.fetch();
					})
				},
				// '/v2/signature/new': () => {
				//     this.setState({
				//         mode: 'create'
				//     })
				// },
				// '/v2/signature/:signature_id': (params) => {
				//     this.setState({
				//         mode: 'view',
				//         params: params,
				//         is_table_loading: true,
				//     }, () => {
				//         this.view();
				//     });
				// },
				// '/v2/signature/:signature_id/edit': (params) => {
				//     this.setState({
				//         mode: 'edit',
				//         params: params,
				//         is_table_loading: true,
				//     }, () => {
				//         this.edit();
				//     });
				// }
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.fetch();
		}
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'view') {
			this.view();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
	}

	edit() {
		let data = {};
		data.signature_id = this.state.params.signature_id;
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
			data: data,
			done: (response) => {
				this.setState({
					is_table_loading: false,
					signature: response.signature[0]
				});
			},
			fail: () => {

			}
		});
	}

	view() {
		let data = {};
		data.signature_id = this.state.params.signature_id;
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
			data: data,
			done: (response) => {
				this.setState({
					is_table_loading: false,
					signature: response.signature[0]
				});
			},
			fail: () => {

			}
		});
	}

	fetch() {
		this.setState({
			is_loading: true,
			dates: [],
		}, () => {
			this.setState({
				is_loading: false,
			})
		});

		let data = window.Global.getAllQueryStrings();

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/file_upload_audit/group',
			data: data,
			done: (response) => {
				this.setState({
					is_loading: false,
					dates: response.dates,
				}, () => {
					// if (response.created_user) {
					//     this.$parent.find('form').find('input[name="created_user_id"]').explorer('set value', response.created_user);
					// }

					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.dates,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				});
				// window.Route.setLink();
			},
			fail: () => {

			}
		});
	}

	renderView() {
		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
				// Route.setLink();
			}} className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className="section active"
							      to="/v2/my-signature">
								ลายเซ็น
							</Link>
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div
								className="section">{this.state.signature.title} {this.state.signature.position ? '(' + this.state.signature.position + ')' : null}</div>
						</div>
					</div>
				</div>
				<div
					className={this.state.is_table_loading ? "ui tall stacked loading segment" : "ui tall stacked segment"}>
					<form className="ui form" autoComplete="off">
						<div className="flex row middle-xs"
						     style={{padding: '0 0 9px 0'}}>
							<h2 style={{margin: 0}}>
								ข้อมูลลายเซ็น
							</h2>
							<div className="flex row right floated">
								<div className="ui basic gray buttons">
									{/*<div className="ui button"*/}
									{/*     onClick={*/}
									{/*	     () => this.printPdf()*/}
									{/*     }>*/}
									{/*	พิมพ์เอกสาร*/}
									{/*</div>*/}
									{
										this.state.signature.is_void === 0
											?
											<>
												<Link className="ui button"
												      to={"/v2/my-signature/" + this.state.signature.id + '/edit'}>
													แก้ไข
												</Link>
												<div className="ui button"
												     onClick={() => {
													     window.Global.confirm({
														     title: 'ยกเลิก',
														     content: window.Handlebars.compile('<form class="ui form" autocomplete="off">\n\t<p>โปรดยืนยันยกเลิก การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>')({}),
														     cancel_text: 'ไม่ดำเนินการ',
														     approve_text: 'ยกเลิกเอกสาร',
														     onShowToSetupForm: ($modal) => {
															     $modal.find('form').form2('setup');
															     $modal.find('form').form2('submit', {
																     method: 'DELETE',
																     url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
																     loadingButton: $modal.find('.button'),
																     beforeSent: (data) => {
																	     data.signature_id = this.state.signature.id;
																	     return data;
																     },
																     onSuccess: (response) => {
																	     $modal.modal('hide');
																	     window.Global.messageTop({
																		     type: 'positive',
																		     message: 'ยกเลิกเรียบร้อย'
																	     });
																	     this.props.history.push({
																		     pathname: '/v2/my-signature',
																		     state: null,
																	     });

																     }
															     });
														     }
													     });
												     }}>
													ยกเลิก
												</div>
											</>
											: null
									}
								</div>
							</div>
						</div>

						<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
						<div className={"flex row wrap padded four column computer"}>
							<div className="column field">
								<label>ชื่อ-นามสกุล</label>
								{this.state.signature.title}
							</div>
							<div className="column field">
								<label>ตำแหน่ง</label>
								{this.state.signature.position}
							</div>
							<div className="column field">
								<label>ลายเซ็น</label>
								{
									this.state.signature
									&& this.state.signature.file_upload
									&& this.state.signature.file_upload.url ?
										<img src={this.state.signature.file_upload.url} alt={"FileUploadAuditImage"}
										     style={{maxHeight: 80}}/>
										: null
								}


							</div>
						</div>

					</form>
				</div>
			</div>
		);
	}

	renderItem(file_upload_audit) {
		// console.log(file_upload_audit);
		return (
			<div key={file_upload_audit.id}
			     id={'file_upload_audit_' + file_upload_audit.id}
			     className="flex row middle-xs center-xs file-upload-audit"
			     ref={(ref) => {
				     let $parent = window.$(ref);

				     $parent.data('file_upload_audit', file_upload_audit);

				     $parent.on('click', (e) => {
					     if (window.$(e.target).closest('.selected-button').length) {
						     let is_selected = $parent.hasClass('selected');
						     this.onTouchSelectedButton(file_upload_audit, !is_selected);

						     this.checkSelectedAllDate($parent.closest('.file-upload-audit-date'));
					     } else {
						     let gallery = [{
							     ...file_upload_audit.file_upload,
							     file_path: file_upload_audit.file_upload.url
						     }]
						     window.Gallery.show(gallery, 0);
					     }
				     });

				     let key = '_' + file_upload_audit.id;
				     if (window.file_upload_audit_selected[key]) {
					     $parent.addClass('selected');
				     }
			     }}
			>
				{
					file_upload_audit.is_audit === 0
						?
						<div className="flex row wrap control">
							<div className="selected-button">
								<i className="check circle icon"></i>
							</div>
						</div>
						: null
				}
				{
					file_upload_audit.file_upload.mime.indexOf('pdf') === -1
						?
						<img src={file_upload_audit.file_upload.url}
						     alt={file_upload_audit.file_upload.original_filename}/>
						:
						<div>{file_upload_audit.file_upload.original_filename}</div>
				}
				{
					file_upload_audit.is_audit
						?
						<div className="is-audit flex row wrap">
							<div data-tooltip="นักบัญชีตรวจสอบแล้ว"
							     data-inverted=""
							     data-position="top left">
								<i className="shield alternate icon"></i>
							</div>
						</div>
						: null
				}
			</div>
		)
	}

	onTouchSelectedButton(file_upload_audit, is_selected) {
		let key = '_' + file_upload_audit.id;
		let $file_upload_audit = window.$('#file_upload_audit_' + file_upload_audit.id);

		if (file_upload_audit.is_audit) {
			is_selected = false;
		}

		if (is_selected) {
			// add
			window.file_upload_audit_selected[key] = {
				file_upload_audit: file_upload_audit,
			}
			$file_upload_audit.addClass('selected');
		} else {
			// remove
			delete window.file_upload_audit_selected[key];
			$file_upload_audit.removeClass('selected');
		}

		let count = Object.keys(window.file_upload_audit_selected).length;

		this.updateButton(count);
	}

	updateButton(count) {
		let $delete_button = window.$('#delete-button');
		$delete_button.text('ลบ ' + count + ' รายการ');

		if (count > 0) {
			$delete_button.show();
		} else {
			$delete_button.hide();
		}
	}

	getSelectedId() {
		let file_upload_audit_ids = [];
		for (const [key] of Object.entries(window.file_upload_audit_selected)) {
			file_upload_audit_ids.push(window.file_upload_audit_selected[key].file_upload_audit.id);
		}
		return file_upload_audit_ids;
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container file-upload-audit-container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="flex row wrap middle-xs">
							<div style={{lineHeight: 1, marginRight: '0.8rem'}}>
								<i className="file alternate outline icon" style={{fontSize: '3.5rem'}}></i>
							</div>
							<div>
								<Link to="/v2/file-upload-audit">
									<h1 style={{margin: 0, color: '#000'}}>อัพโหลดเอกสาร</h1>
								</Link>
								<div style={{
									fontSize: '1rem',
									marginTop: '0.7rem'
								}}>{window.user.company.company_name} สาขา {window.user.current_branch.name}</div>
							</div>
						</div>
						<div className="flex row wrap right floated upload-button-wrapper">
							<div id="upload-button"
							     ref={(ref) => {
								     let $upload = window.Global.makeUploadButton({
									     customButton: '<div class="ui primary button big">อัพโหลด</div>',
									     uploadFile: {
										     input: {
											     name: ''
										     },
										     textOnButton: 'อัพโหลด',
										     showImagePreview: false
									     },
									     acceptFileTypes: /(\.|\/)(jpe?g|png|pdf)$/i,
									     singleFileUploads: false,
									     element: window.$(ref),
									     url: process.env.REACT_APP_DOMAIN + '/api/file/inline-upload',
									     maxFileUpload: 99999999,
									     key_file_data: 'files',
									     formData: {
										     type: 'normal',
										     source: "file_upload_audit",
									     },
									     beforeSend: function (xhr, data) {
										     // let file = data.files[0];
										     // xhr.setRequestHeader('X-FileName', file.name);
										     if (window.location.host.indexOf('localhost') !== -1) {
											     xhr.setRequestHeader('Authorization', 'FoU8bogqqhnKev3TCV32Fhb4EBvDlLhlofanXHOqwQ2LPa8eht7oT5ohfpVjjvPVlQqJwBJDMD7DlXJccDJ6FlI7ynSyefTDViRwTrXtHTQqlBeyXQNzQTJQbvylZvHPoU5n1Tv28HbdLoqY8n1mxrUA6cbA6uYdT2HvdF0qfQyCUw6d6ApV5jrHuczBgYw4rUlaKmE2xCClvplG4VGT98YsAriE58cMys2YVJrSRxNS8BuGB3nTCyn6CNumFfZ');
										     }
										     // 'Content-Type': 'multipart/form-data',
										     // 'Authorization': token,
									     },
									     onUploadDone: (data) => {
										     // console.log(data);
										     // if (this.props.onUploadDone) {
										     //    return this.props.onUploadDone(response);
										     // }

										     if (
											     data.result.error
											     || data.result.file_upload_audits.length === 0
										     ) return true;

										     let day = data.result.file_upload_audits[0].date_created.substr(0, 10);

										     let dates = [...this.state.dates];
										     let index_found = -1;
										     for (let i = 0; i < this.state.dates.length; i++) {
											     if (this.state.dates[i].date === day) {
												     index_found = i;
												     break;
											     }
										     }

										     if (index_found === -1) {
											     // ไม่เจอวันนี้
											     dates.unshift({
												     date: day,
												     date_readable: 'วันนี้',
												     file_upload_audits: data.result.file_upload_audits,
											     })
										     } else {
											     let __file_upload_audits = dates[index_found].file_upload_audits;
											     __file_upload_audits.unshift(...data.result.file_upload_audits.reverse());

											     dates[index_found].file_upload_audits = __file_upload_audits
										     }

										     // let file_upload_audits = this.state.file_upload_audit;
										     // file_upload_audits.unshift({
										     //    ...data.result.file_upload_audits[0],
										     //    is_loading: 0
										     // });

										     this.setState({
											     dates: dates,
											     // file_upload_audit: [...file_upload_audits],
										     });

										     return true;
									     },
									     onSuccess: (data) => {
										     console.log(data);
										     // if (this.props.onSuccess) {
										     //    return this.props.onSuccess(data);
										     // }
									     },
									     onRemove: (data) => {
										     console.log(data);
									     },
									     onProcess: (data) => {
										     console.log(data);
									     },
									     onFail: (e, data) => {
										     console.log(e, data);
									     }
								     });

								     $upload.closest('#upload-button').find('.Upload_fileRoot').remove();

								     $upload.removeClass('tiny basic')
									     .addClass('primary big');

								     $upload.closest('#upload-button').find('input[type="file"]')
									     .attr('accept', '.png, .jpeg, .jpg, application/pdf')
							     }}
							>
								อัพโหลด
							</div>
							<div id="delete-button"
							     style={{display: Object.keys(window.file_upload_audit_selected).length > 0 ? 'block' : 'none'}}
							     className="ui red button big"
							     onClick={() => {
								     let title = 'ลบข้อมูล ' + Object.keys(window.file_upload_audit_selected).length + ' รายการ';

								     window.Global.confirm({
									     title: title,
									     content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
									     cancel_text: 'ไม่ดำเนินการ',
									     approve_text: title,
									     onShowToSetupForm: ($modal) => {
										     $modal.find('form').form2('setup');
										     $modal.find('form').form2('submit', {
											     method: 'DELETE',
											     url: process.env.REACT_APP_DOMAIN + '/api/file_upload_audit',
											     loadingButton: $modal.find('.button.approve'),
											     beforeSent: (data) => {
												     data.file_upload_audit_ids = this.getSelectedId();
												     return data;
											     },
											     onSuccess: (response) => {
												     $modal.modal('hide');
												     window.Global.messageTop({
													     type: 'positive',
													     message: 'ลบข้อมูลสำเร็จ'
												     });
												     window.location.reload();
											     }
										     });
									     }
								     });
							     }}
							>
								ลบ
							</div>
						</div>
					</div>
					<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
					     ref={(ref) => {
						     let $search = window.$(ref);
						     // window.Search.init({
						     //    $node: $search,
						     //    onSubmit: (data) => {
						     //      this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
						     //      return false;
						     //    }
						     // });
						     $search.find('input[name="created_user_id"]').explorer({
							     url: process.env.REACT_APP_DOMAIN + '/api/user',
							     additionalData: () => {
								     return {
									     limit: 10
								     }
							     },
							     key: 'user',
							     template: {
								     list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<b style="color: darkgreen;">{{name}}</b>\n\t</div>\n</a>',
								     selected: {
									     display_template: '{{name}}',
									     value: 'id',
									     placeholder: 'ผู้บันทึก'
								     }
							     }
						     });
					     }}>
						<form className="ui form">
							<div className="flex row wrap padded five column computer">
								<div className="column field">
									<div className="field">
										<label>ชื่อนามสกุล</label>
										<input type="text" name="title" placeholder="ชื่อนามสกุล"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ตำแหน่ง</label>
										<input type="text" name="position" placeholder="ตำแหน่ง"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ผู้บันทึก</label>
										<input type="text" name="created_user_id"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>สถานะ</label>
										<select name="status"
										        className="ui dropdown fluid"
										        data-form2_setup="">
											<option value="active">ใช้งาน</option>
											<option value="void">ยกเลิก</option>
											<option value="all">ทั้งหมด</option>
										</select>
									</div>
								</div>
								<div className="column fluid right floated">
									<label style={{opacity: 0}}>อื่นๆ</label>
									<div className="flex row wrap right floated end-xs">
										<button className="ui icon button green"
										        type="submit">
											<i className="search icon"/> ค้นหา
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
				{/*<br/>*/}
				<div className="flex row wrap padded">
					<div className="col-xs-16 padded">
						<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 0}}>
							{/*<div className="thead">*/}
							{/*    <div className="tr">*/}
							{/*        <div className="th span4">ชื่อนามสกุล</div>*/}
							{/*        <div className="th span3">ตำแหน่ง</div>*/}
							{/*        <div className="th span3">ลายเซ็น</div>*/}
							{/*        <div className="th span3">สถานะ</div>*/}
							{/*        <div className="th span3">ผู้บันทึก</div>*/}
							{/*    </div>*/}
							{/*</div>*/}
							<div className="tbody">
								{
									this.state.is_loading
										? <div className="tr">
											<div className="td center aligned" data-info="nodata">
												<div className="ui active centered inline small loader"/>
											</div>
										</div>
										: null
								}
								{
									this.state.dates.length === 0
									&& !this.state.is_loading
									&& (
										!window.Global.getAllQueryStrings().page
										|| window.Global.getAllQueryStrings().page === '1'
									)
										? <div className="tr">
											<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
										</div>
										: null
								}
								{
									this.state.dates
									&& this.state.dates.length > 0 ?
										this.state.dates.map((date, date_index) => {
											let total = date.file_upload_audits.length;
											let total_is_audit = 0;

											for (let x = 0; x < total; x++) {
												if(date.file_upload_audits[x].is_audit){
													total_is_audit++;
												}
											}

											return (
												<div className="tr file-upload-audit-date"
												     key={date_index}
												     ref={(ref) => {
													     let $parent = window.$(ref);
													     let $button = $parent.find('.selected-button.all');

													     $button.on('click', () => {
														     if (!$button.hasClass('selected')) {
															     $button.addClass('selected');
														     } else {
															     $button.removeClass('selected');
														     }

														     $parent.find('.file-upload-audit').each((i, e) => {
															     let is_selected = window.$(e).hasClass('selected');
															     this.onTouchSelectedButton(window.$(e).data('file_upload_audit'), !is_selected);
														     });
													     });

													     // check all selected
													     this.checkSelectedAllDate($parent);
													     // end
												     }}
												>
													<div>
														<div style={{
															padding: '1.2rem 1.3rem 1.3rem 1.3rem',
															fontSize: '1.5rem',
															fontWeight: 'bold',
														}}
														     className="flex row wrap"
														>
															<div className="selected-button all"
															     onClick={() => {
																     // this.onTouchSelectedButton(file_upload_audit);
															     }}>
																<i className="check circle icon"></i>
															</div>
															<div style={{marginRight: '1rem'}}>
																{date.date_readable}
															</div>
															<div style={{marginRight: '1rem'}}>
																<span data-tooltip={"เอกสารทั้งหมด " + total.format() + ' รายการ'}
																     data-inverted=""
																     data-position="top left">
																	<i className="camera icon"></i> {total.format()}
																</span>
															</div>
															<div>
																<span data-tooltip={"นักบัญชีตรวจสอบแล้ว " + total_is_audit.format() + ' รายการ'}
																      data-inverted=""
																      data-position="top left">
																	<i className="check icon"></i> {total_is_audit.format()}
																</span>
															</div>
														</div>
														<div className="flex row wrap">
															{
																date.file_upload_audits.map((file_upload_audit, file_upload_audit_index) => {
																	return this.renderItem(file_upload_audit);
																})
															}
														</div>
													</div>
												</div>
											)
										})
										: null
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		if (this.state.mode === 'view') {
			return this.renderView();
		}
		if (this.state.mode === 'edit' && !this.state.signature) return (<div/>);
		return null;
	}

	checkSelectedAllDate($parent) {
		let is_selected = true;
		let fix_count = 0;

		$parent.find('.file-upload-audit').each((i, e) => {
			if (window.$(e).data('file_upload_audit').is_audit) {
				return;
			}

			if (!window.$(e).hasClass('selected')) {
				is_selected = false;
			} else {
				fix_count++;
			}
		});

		if (is_selected
			&& fix_count !== 0
		) {
			$parent.find('.selected-button.all').addClass('selected');
		} else {
			$parent.find('.selected-button.all').removeClass('selected');
		}
	}
}
